// eslint-disable-next-line no-undef
export const finalizer = new FinalizationRegistry(callback => callback());
